module.exports = __webpack_public_path__ + "static/media/logo.ff97f41c.svg";